import type { AxiosResponse } from "axios";

import { ClientGateway } from "@kex/api";
import { type InfiniteData, useQueryClient } from "@tanstack/react-query";

import { constants } from "./constants";

export const useRequisitesQuery = () => {
  const queryClient = useQueryClient();

  const removeById = (id: string) => {
    queryClient.setQueryData(
      constants.list(),
      (
        oldData: InfiniteData<
          AxiosResponse<ClientGateway.GetBankAccountsListResponse>
        >,
      ) => {
        if (!oldData) {
          return oldData;
        }

        return {
          ...oldData,
          pages: oldData.pages.map((page) => ({
            ...page,
            data: {
              ...page.data,
              data: page.data.data.filter((item) => item.id !== id),
              pagination: {
                ...page.data.pagination,
                pageCount: page.data.pagination.pageCount - 1,
              },
            },
          })),
        } satisfies InfiniteData<
          AxiosResponse<ClientGateway.GetBankAccountsListResponse>
        >;
      },
    );
    queryClient.removeQueries({ queryKey: constants.detail(id) });
  };

  const invalidateRequisites = async () => {
    await queryClient.invalidateQueries({
      queryKey: constants.default(),
    });
  };

  return { invalidateRequisites, removeById };
};
